<template>
	<div class="basis-page-cls">
        <section class="basis-cls_table">
            <div class="table">
				<table-pagination
                    :data="list"
                    :column="column" />
            </div>
        </section>
		<!-- 人管管理 -->
		<PeopleBox ref="peopleBox" />
		<LevelBox ref="LevelBox" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import PeopleBox from './people';
import LevelBox from './level';
export default {
	components: {PeopleBox, LevelBox},
	computed: {
        ...mapGetters([
			'userInfo',  
		])
    },
	data() {
		return {
            column: [
				{ label: '技能组标识', prop: 'queueName' },
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 160,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<div>
								<el-button type="text" size="small" onClick={() => this.onPeople(scope.row)}>
									人员管理
								</el-button>
								<el-divider direction="vertical"></el-divider>
								<el-button size="small"
									onClick={() => this.onLevel(scope.row)}
									type="text">
									优先级设置
								</el-button>
							</div>
						)
                    }
                }
            ],
			listQuery: {
				pageSize: 100,
                pageNumber: 1,
				projectCode: ''
            },
			list: []
		}
    },
	created() {
		this.getList();
	},
	methods: {
		getList() {
			this.listQuery.projectCode = this.userInfo.brandIdentify;
			this.$api.apiPostLarkswitchManageQueueList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data;
			});
		},
		onPeople(row){
			this.$refs.peopleBox.onOpen(row);
		},
		onLevel(row) {
			this.$refs.LevelBox.onOpen(row);
		}
    }
}
</script>